import React from 'react';
import ReactHTMLParser from 'react-html-parser';
import { connect } from 'react-redux';

import * as actions from './duck';
import styles from './index.module.less';

import { Divider, IntlMessage, Spinner } from '$HVUI';
import Button from '$Molecules/Buttons/Button';
import { fieldDisplayValue } from '$Utils';
import { normalizeCSSID } from '$Validation/Normalizer';

export class Review extends React.Component {
    componentDidMount() {
        this.props.getCompleteReview();
    }
    render() {
        const {
            review: forms,
            history,
            organizationID,
            ourIntl: { locale: language }
        } = this.props;

        const isProduction = process.env.NODE_ENV == 'production';

        //Loading state; might need tweaking
        if (forms == null)
            return (
                <div>
                    <Spinner size={30} id="review-loading" />
                </div>
            );

        if (forms.length === 0) {
            return (
                <div>
                    <h1 style={{ marginTop: '24px' }}>
                        <IntlMessage
                            id="review.registration-forms"
                            defaultMessage="Registration Forms"
                        />
                    </h1>
                    <p style={{ marginTop: 24 }}>
                        <IntlMessage
                            id="review.we-could-not-find-any-forms-for"
                            defaultMessage="We could not find any forms for you. Please see the
                        front desk staff."
                        />
                    </p>
                    {!isProduction && (
                        <>
                            <h2 style={{ marginTop: '24px' }}>
                                Healthvana Internal Note
                            </h2>
                            <p>
                                <span
                                    style={{ fontWeight: 700 }}
                                    className="text-navy"
                                >
                                    Organization {organizationID}
                                </span>
                                <br />
                                on <br />
                                <span
                                    style={{ fontWeight: 700 }}
                                    className="text-navy"
                                >
                                    {window.location.href}
                                </span>
                                <br />
                                has no forms configured for dReg.
                            </p>
                            <p>
                                Contact the developer and/or use another
                                organization.
                            </p>
                        </>
                    )}
                    <p>
                        <Button
                            id="button-submit"
                            element="link4"
                            text={
                                <IntlMessage
                                    id="all.continue"
                                    defaultMessage="Continue"
                                />
                            }
                            to="/assessments"
                        />
                    </p>
                </div>
            );
        }

        return (
            <div style={{ textAlign: 'left' }}>
                <h1>
                    <IntlMessage id="review.review" defaultMessage="Review" />
                </h1>
                <p>
                    <IntlMessage
                        id="review.please-review-your-information-if-everything-looks"
                        defaultMessage="Please review your information. If everything looks correct,
                    click continue."
                    />
                </p>
                {forms.map(form => {
                    const { title, fields, id, fobiID } = form;
                    if (!fields || !fields.length) return '';
                    const split = Math.round(fields.length / 2);
                    // If there are more than a certain number of fields, push to two columns
                    const grid = fields.length > 6;
                    // and specify a grid
                    const style = grid
                        ? { gridTemplateRows: `repeat(${split}, auto)` }
                        : null;
                    return (
                        <div key={`${id}-${fobiID}`}>
                            <div className={styles['review-container']}>
                                <h2 className={styles['review-form-title']}>
                                    {title}
                                </h2>
                                <Divider style={{ marginBottom: 16 }} />
                                <div
                                    className={
                                        grid
                                            ? styles['review-form-grid']
                                            : styles['review-form']
                                    }
                                    style={style}
                                >
                                    {fields.map(field => {
                                        const {
                                            label = '',
                                            name,
                                            fieldExtras = {}
                                        } = field;
                                        const { label_es, htmlLabel } =
                                            fieldExtras;

                                        let finalLabel =
                                            language === 'es' &&
                                            label_es?.triggerValue
                                                ? label_es.triggerValue
                                                : label;

                                        const displayValue = fieldDisplayValue(
                                            field,
                                            language
                                        );

                                        return (
                                            <div
                                                key={finalLabel}
                                                className={styles['field']}
                                            >
                                                <div
                                                    className={styles['label']}
                                                >
                                                    {htmlLabel
                                                        ? ReactHTMLParser(
                                                              finalLabel
                                                          )
                                                        : finalLabel}
                                                    :
                                                </div>
                                                <div
                                                    className={styles['value']}
                                                    data-label={normalizeCSSID(
                                                        `dl-${name}`
                                                    )}
                                                >
                                                    {displayValue}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className={styles['button-container']}>
                                <Button
                                    kind="secondary"
                                    icon="pencil"
                                    text={
                                        <IntlMessage
                                            id="review.edit-answers"
                                            defaultMessage="Edit answers"
                                        />
                                    }
                                    onClick={() => {
                                        const path = `/review-form/${form.uuid}/`;
                                        return history.push(path);
                                    }}
                                />
                            </div>
                        </div>
                    );
                })}
                <div className={styles['button-container']}>
                    <Button
                        id="button-submit"
                        kind="primary"
                        text={
                            <IntlMessage
                                id="all.continue"
                                defaultMessage="Continue"
                            />
                        }
                        element="link4"
                        to="/assessments"
                    />
                </div>
            </div>
        );
    }
}

export const mapStateToProps = (state, ownProps) => {
    const { review } = state;
    const organizationID =
        (state.introduction &&
            state.introduction &&
            state.introduction.organization.id) ||
        '';

    return Object.assign(
        {},
        {
            review,
            organizationID
        },
        ownProps
    );
};

export default connect(mapStateToProps, actions)(Review);
